import { render } from "./SectionsDetailRelationInfoTables.vue?vue&type=template&id=098b8d44"
import script from "./SectionsDetailRelationInfoTables.vue?vue&type=script&lang=js"
export * from "./SectionsDetailRelationInfoTables.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__